import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://aujaa-group-api.onrender.com/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const requestService = {
  // Soumettre une demande
  submitRequest: (requestData) => api.post('/requests', requestData),
  
  // Récupérer toutes les demandes (admin)
  getAllRequests: () => api.get('/requests/admin/requests'),
  
  // Mettre à jour le statut (admin)
  updateRequestStatus: (id, status) => 
    api.put(`/requests/admin/requests/${id}/status`, { status }),
};